<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-col class="com-mb-graph pa-0" ref="graphBox">
        <v-row class="com-mb-card-header">
          <span class="com-mb-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="white" @click="$emit('close')">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-col class="com-mb-card-contents pb-0">
          <tm-sw-stage-x-sec
            :width="stageCrossWidth"
            :height="stageCrossHeight"
            :isExpansion="scalModeXSec"
            :isLegend="isLegendDisp"
          ></tm-sw-stage-x-sec>
        </v-col>
        <v-col class="pa-0">
          <v-row class="tm-mb-graph-select-box pa-1" no-gutters>
            <v-spacer></v-spacer>
            <v-btn
              tile
              depressed
              x-small
              class="graph-btn"
              color="success"
              width="50px"
              :outlined="scalModeXSec === true"
              @click="scalModeXSec = false"
              >{{ text.btn.zoomout }}</v-btn
            >
            <v-btn
              tile
              depressed
              x-small
              class="graph-btn"
              color="success"
              width="50px"
              :outlined="scalModeXSec === false"
              @click="scalModeXSec = true"
              >{{ text.btn.zoomin }}</v-btn
            >
            <v-btn
              depressed
              x-small
              class="legend-btn"
              color="orange"
              width="50px"
              dark
              :outlined="!isLegendDisp"
              @click="isLegendDisp = !isLegendDisp"
            >
              <v-icon small>import_contacts</v-icon>
              {{ text.btn.legend }}
            </v-btn>
          </v-row>
        </v-col>
      </v-col>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]危機管理型水位計 河川横断図拡大表示ダイアログ
 * TmStageXSecDlg.vue
 * @author ILUKE
 */

import TmSwStageXSec from "./TmSwStageXSec";
export default {
  name: "tm-sw-stage-x-sec-dlg",
  components: {
    TmSwStageXSec,
  },
  data() {
    return {
      stageCrossWidth: null,
      stageCrossHeight: null,
      dispConfFlg: false,
      active: false,
      cross: {},
      isDispCross: false,
      loading: true,
      isScrollMode: true,
      isShowLegend: false,
      sliderIdx: 0,
      text: {
        title: "河川横断図",
        btn: {
          zoomout: "全体",
          zoomin: "拡大",
          legend: "凡例",
        },
      },
    };
  },
  props: {
    /** 親要素の幅 */
    width: {
      type: Number,
      default: 500,
    },
    /** 親要素の高さ */
    height: {
      type: Number,
      default: 220,
    },
    /** 拡大/全体指定 */
    isExpansion: {
      type: Boolean,
      default: true,
    },
    /** 凡例表示 */
    isLegend: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** 横断図拡縮表示設定 取得 */
    scalModeXSec: {
      get() {
        return this.$store.state.Telemeter.scalModeXSec;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalModeXSec", val);
      },
    },
    /** 凡例表示状態 取得 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },
  },
  created() {
    this.stageCrossWidth = this.width;
    this.stageCrossHeight = this.height;
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.graphBox !== undefined) {
          const offsetWidth = this.$refs.graphBox.offsetWidth;
          const offsetHeight = this.$refs.graphBox.offsetHeight;
          if (offsetWidth > 0 && offsetHeight > 0) {
            this.stageCrossWidth = offsetWidth - 48;
            this.stageCrossHeight = offsetHeight - 84;
          }
        }
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
